export type PrevailingRhythm = "SR" | "?" | "AF";

export function calculatePrevailingRhythm(afibBurden: number | undefined): PrevailingRhythm | undefined {
  return afibBurden === undefined
    ? undefined
    : afibBurden === 0
      ? "SR"
      : afibBurden < 90
        ? "?"
        : "AF";
}

